export default class GlobalSlimBanner {

	constructor (elem) {
		this.elem = elem;
		this.afterCountdownContent = this.elem.getAttribute('data-after-countdown-content');
		this.timestamp = parseInt(this.elem.getAttribute('data-deadline'), 10);
		this.countdownHours = this.elem.querySelector('.js-countdown_hours');
		this.countdownMinutes = this.elem.querySelector('.js-countdown_minutes');
		this.countdownSeconds = this.elem.querySelector('.js-countdown_seconds');

		this.init();
	}

	init () {
		this.initializeClock();
	}

	initializeClock () {
		const self = this;

		self.updateClock();
		self.timeinterval = setInterval(() => {
			self.updateClock();
		}, 1000);
	}

	updateClock () {
		const timeDifference = (new Date(this.timestamp * 1000).getTime() - new Date().getTime()) / 1000;

		if (timeDifference <= 0) {
			this.timerDone();

			return;
		}

		let timeLeft = timeDifference;
		const hours = Math.floor(timeLeft / 3600);
		timeLeft -= hours * 3600;

		const minutes = Math.floor(timeLeft / 60);
		timeLeft -= minutes * 60;

		const seconds = Math.floor(timeLeft);

		if (!this.countdownHours) {
			return;
		}

		this.countdownHours.innerHTML = hours;
		this.countdownMinutes.innerHTML = ('0' + minutes).slice(-2);
		this.countdownSeconds.innerHTML = ('0' + seconds).slice(-2);
	}

	timerDone () {
		if (this.timeinterval) {
			clearInterval(this.timeinterval);
		}

		this.elem.innerHTML = this.afterCountdownContent;
	}

}
